import { widgetStore } from '../store';
import { useSelectedFieldStore } from './useSelectedFieldStore';

export type UseIsTimelineWidgetArg = {
  widgetId: string;
};

export const useIsTimelineWidget = ({ widgetId }: UseIsTimelineWidgetArg) => {
  return useSelectedFieldStore(
    widgetStore,
    () => widgetStore.get()[widgetId]?.isTimelineWidget
  );
};
